module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/socials/apple-bf94908b056e871d76c297b42c868e37.svg";